export default "__VITE_ASSET__gMcxu23E__"